  <!-- ======= Hero Section ======= -->
  <section id="hero" class="d-flex flex-column justify-content-center">
    <div class="container" data-aos="zoom-in" data-aos-delay="100">
      <h1>{{titular.nombre}}</h1>
      <p>Soy <strong> <span class="typed" data-typed-items="Designer, Developer, Freelancer, Photographer">{{titular.ocupacion}}</span></strong></p>
      <p>Celular: <strong><span class="typed">{{titular.celular}}</span></strong></p>
      <div class="social-links">
        <a *ngFor="let red of socialreds" [href]="red.url" [class]="red.class"><i [class]="red.icon"></i></a>
        <!-- <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a> -->
      </div>
    </div>
  </section><!-- End Hero -->
